import React from "react";

import { SideBar } from "../SideBar";
import { NaveBar } from "../NaveBar";
import { Box, Stack, Backdrop } from "@mui/material";
import { useLocation } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

const Layout = ({ children }: Props) => {
  return (
    <Stack direction="row">
      <SideBar />
      <Stack
        direction="column"
        width={1}
        height="100vh"
        overflow="hidden"
        position="relative"
      >
        <Box sx={{ position: "static", width: 1, top: 0 }}>
          <NaveBar />
        </Box>
        <Box p={5} flexGrow={1} bgcolor="grey.100" overflow="auto" width={1}>
          {children}
        </Box>
      </Stack>
    </Stack>
  );
};

export { Layout };
